module.exports = __webpack_public_path__ + "img/LATAM_MILK.c083ccd6.png";